module.exports = __webpack_public_path__ + "img/project3@2x.e99debe2.jpg";